/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TruckBedShort = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 68 73" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M29.6 41.6c4.6 0 9.1 1.8 12.3 5.1h21V21.2H6.4V.5H.1v46.2h17.1c3.3-3.3 7.7-5.1 12.4-5.1zm26.5-6.7c0-.8.7-1.4 1.4-1.4h1.3c.8 0 1.4.7 1.4 1.4v7.8c0 .8-.7 1.4-1.4 1.4h-1.3c-.8 0-1.4-.7-1.4-1.4v-7.8zM.1 49.8v9.6h12v-.3c0-3.3.9-6.5 2.7-9.3H.1zM66 49.8H44.4c1.7 2.8 2.6 6 2.6 9.3v.3h19c.9 0 1.6-.7 1.6-1.6v-6.4c0-.9-.7-1.6-1.6-1.6z" /><circle cx="29.5" cy="59" r="13.7" /></g>
      </g>
    </svg>
  </span>
);

TruckBedShort.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TruckBedShort.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TruckBedShort;
